var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-pdf-box"},[_c('h3',{staticClass:"video-player-h3"},[_c('i',{staticClass:"el-icon-circle-close video-player-icon",on:{"click":function($event){return _vm.closePdf('close')}}})]),_c('iframe',{staticClass:"pdf-box",attrs:{"src":_vm.embedPdfUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }